module.exports = __webpack_public_path__ + "static/media/boy_thinking_talk_only.0a4f0bac.gif";